module.exports = __webpack_public_path__ + "static/media/icon_Language.4734b99d.png";